/* unplugin-vue-components disabled */import script from "./MatchAnalysisView.vue?vue&type=script&setup=true&lang=js"
export * from "./MatchAnalysisView.vue?vue&type=script&setup=true&lang=js"

import "./MatchAnalysisView.vue?vue&type=style&index=0&id=27781f62&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27781f62"]])

export default __exports__